import { ApplicationState } from '../..';

export const rimPreviousView = (state: ApplicationState) => state.details.detailsRim.currentView;
export const svsPreviousView = (state: ApplicationState) => state.details.detailsSvs.currentView;
export const caseCode = (state: ApplicationState) => state.details.detailsCase.caseCode;
export const currentRoles = (state: ApplicationState): string[] => state.shared.roles;
